import clsx from "clsx";
import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

function Modal({ open, children, className, onClose = undefined }) {
  const modalRef = useRef(null);
  const container = document.getElementById("root");

  useEffect(() => {
    if (open) {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      document.body.classList.add("overflow-hidden");
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      document.body.classList.remove("overflow-hidden");
      document.body.style.paddingRight = "";
    }
  }, [open]);

  if (!container) throw new Error("Not found container");

  return (
    open &&
    container &&
    createPortal(
      <div
        className={clsx(
          "fixed inset-0 bg-[#242E4299] bg-opacity-40 z-50 flex items-center justify-center p-4",
          className
        )}
        ref={modalRef}
        onClose={onClose}
        onClick={onClose}
      >
        <div
          className="bg-white rounded-lg shadow-xl max-h-[90vh] overflow-auto"
          onClick={(event) => event.stopPropagation()}
          style={{ maxWidth: 'min(95vw, 1300px)' }} // Dynamic max width
        >
          {children}
        </div>
      </div>,
      container
    )
  );
}

export default Modal;